import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.public.programs');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-public-programs',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.public.programs/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PagePublicProgramsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public programs: any[] = [];

    public async ngOnInit() {
        await this.service.init();
        const r = await wiz.call('list', {});
        if (r.code === 200) this.programs = r.data.rows || [];
        this.loading = false;
        await this.service.render();
    }

    public goApply(id: string) {
        location.href = `/public/apply/${id}`;
    }

    public formatBudget(n: number): string {
        if (!n) return '-';
        if (n >= 100000000) return `${(n / 100000000).toFixed(1)}억원`;
        if (n >= 10000) return `${(n / 10000).toFixed(0)}만원`;
        return `${n.toLocaleString()}원`;
    }
}

export default PagePublicProgramsComponent;